
const Kumelenme = () => {
  return (
    <> 
      <div className="row justify-content-center mb-4 header-hero pt-4 pb-4">
        <div className="col-md-10 col-sm-12">
          <h2>Clusters</h2>
        </div>
      </div>

      <div className="row justify-content-md-center mb-4">
        <div className="col-md-10 col-sm-12 mt-4">
          <p>In order to enhance collaboration among companies that are leaders in their respective fields in Türkiye, clusters are being established—primarily in the areas of Security, Smart Cities, Traffic, Communications/Telecommunications/Information Technologies—and various cooperation development activities are being carried out.</p>
          <p>Within the scope of clustering programs, which are also supported by various public initiatives, the primary objectives include increasing internationalization activities; strengthening intra-cluster and inter-cluster cooperation; enhancing sectoral know-how; transferring accumulated expertise to other sectors to ensure the efficient use of resources; and enabling the effective planning of new investments.</p>
        </div>
      </div>

      <div className="row justify-content-md-center">
        <div className="col-10">
          <ul>
            <li>The Managing Company organizes both paid and free congresses, seminars, and meetings to meet the training needs of company employees.</li>
            <li>Project markets, sectoral trade delegations, matchmaking events, buyer delegations, participation in international fairs, and various projects are implemented to increase cooperation among companies and to foster international collaboration.</li>
            <li>Coordination activities are conducted among companies located within or outside the Zone, universities, and other R&D institutions and organizations in order to develop technological solutions to challenges encountered by companies during the implementation of their projects.</li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Kumelenme;
